export const STATUS_LIST = [
  '已订舱',
  '已发出',
  '已收货',
  '已安检',
  '已入库',
  '已组板',
  '已起飞',
  '已落地',
  '已提货'

]



// WEBPACK FOOTER //
// ./src/assets/js/constant.js